/* VIDA · Motion core (sin librerías)
   - Revelado al hacer scroll   [data-reveal="up|down|left|right|scale|clip|fade"] [data-reveal-group] (escalonado)
   - Parallax / rotación / escala [data-parallax="0.12"] [data-scroll-object="rot:6;scale:0.9;y:60"]
   - Progreso de sección          [data-scroll-progress]  -> --p (0..1)
   - Inclinación al cursor        [data-tilt="6"]
   - Contadores                   [data-count-to="1200"] [data-count-prefix] [data-count-suffix]
   El scroll nativo del navegador nunca se intercepta. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduce = { get matches() { var m = document.documentElement.getAttribute('data-motion'); return reduceMq.matches || m === 'min' || m === 'off'; } };
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- Revelado ---------- */
  function initReveal() {
    document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-reveal-group'), 10) || 90;
      Array.prototype.forEach.call(group.children, function (child, i) {
        if (!child.hasAttribute('data-reveal') && !child.classList.contains('vida-reveal')) child.setAttribute('data-reveal', group.getAttribute('data-reveal-type') || 'up');
        child.style.setProperty('--d', i * step);
      });
    });
    var items = document.querySelectorAll('[data-reveal]:not(.is-in), .vida-reveal:not(.is-in)');
    if (!items.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Scroll: parallax, objetos y progreso ---------- */
  var live = new Set();
  var ticking = false;
  var listening = false;

  function parseOpts(str) {
    var o = {};
    (str || '').split(';').forEach(function (p) {
      var kv = p.split(':');
      if (kv.length === 2) o[kv[0].trim()] = parseFloat(kv[1]);
    });
    return o;
  }

  /* ---------- Reveal de texto: las palabras se encienden de a poco segun avanza el scroll ---------- */
  function splitWords(el) {
    if (el._split) return;
    el._split = true;
    var words = [];
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
        if (ch.nodeType === 3) {
          var frag = document.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var s = document.createElement('span'); s.className = 'v-w'; s.textContent = part; frag.appendChild(s); words.push(s);
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1) { walk(ch); }
      });
    })(el);
    el._words = words; el._lit = -1;
  }
  function lightAll(el) { if (!el._words) return; el._words.forEach(function (w) { w.classList.add('is-lit'); }); el._lit = el._words.length; }
  function initTextReveal() {
    document.querySelectorAll('[data-text-reveal]').forEach(function (el) {
      splitWords(el);
      if (reduce.matches) lightAll(el);
    });
  }

  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    // Primero se leen todas las medidas y despues se escribe: evita recalcular el layout varias veces por cuadro
    var items = [];
    live.forEach(function (el) { items.push([el, el.getBoundingClientRect()]); });
    items.forEach(function (it) {
      var el = it[0], r = it[1];
      var center = r.top + r.height / 2;
      var t = (center - vh / 2) / (vh / 2 + r.height / 2); // -1 (entra por abajo) .. 1 (sale por arriba)... invertido abajo
      t = Math.max(-1, Math.min(1, t));
      if (el._par) {
        el.style.setProperty('--py', (t * el._par * -100).toFixed(1) + 'px');
      }
      if (el._obj) {
        var o = el._obj;
        // p: 0 cuando el elemento entra, 1 cuando sale
        var p = 1 - (center + r.height / 2) / (vh + r.height);
        p = Math.max(0, Math.min(1, p));
        var k = p * 2 - 1; // -1..1 centrado
        if (o.y != null) el.style.setProperty('--py', (k * o.y).toFixed(1) + 'px');
        if (o.rot != null) el.style.setProperty('--pr', (k * o.rot).toFixed(2) + 'deg');
        if (o.scale != null) el.style.setProperty('--ps', (1 - Math.abs(k) * (1 - o.scale)).toFixed(4));
      }
      if (el._tr && el._words) {
        var tp = Math.max(0, Math.min(1, (vh * 0.9 - r.top) / (vh * 0.45)));
        var lit = Math.round(tp * el._words.length);
        if (lit !== el._lit) { el._words.forEach(function (w, i) { w.classList.toggle('is-lit', i < lit); }); el._lit = lit; }
      }
      if (el._prog) {
        var pr = (vh - r.top) / (vh + r.height);
        var sticky = el.hasAttribute('data-scroll-sticky');
        if (sticky) pr = -r.top / Math.max(1, r.height - vh);
        el.style.setProperty('--p', Math.max(0, Math.min(1, pr)).toFixed(4));
      }
    });
  }

  function request() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  function initScroll() {
    if (reduce.matches) return;
    var els = document.querySelectorAll('[data-parallax], [data-scroll-object], [data-scroll-progress], [data-text-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) live.add(e.target);
        else {
          live.delete(e.target);
          // si el texto ya quedo por encima de la pantalla (scroll rapido), queda completamente encendido
          if (e.target._tr && e.boundingClientRect.top < 0) lightAll(e.target);
        }
      });
      request();
    }, { rootMargin: '20% 0px 20% 0px' });
    els.forEach(function (el) {
      if (el.hasAttribute('data-parallax')) el._par = parseFloat(el.getAttribute('data-parallax')) || 0.1;
      if (el.hasAttribute('data-scroll-object')) {
        el._obj = parseOpts(el.getAttribute('data-scroll-object'));
        // En celular el movimiento es aun mas contenido (pantalla pequena, scroll con el dedo)
        if (window.innerWidth < 750) { if (el._obj.y != null) el._obj.y *= 0.55; if (el._obj.rot != null) el._obj.rot *= 0.6; }
      }
      if (el.hasAttribute('data-scroll-progress')) el._prog = true;
      if (el.hasAttribute('data-text-reveal')) el._tr = true;
      io.observe(el);
    });
    if (!listening) {
      listening = true;
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request, { passive: true });
    }
    request();
  }

  /* ---------- Inclinación ---------- */
  function initTilt() {
    if (reduce.matches || !finePointer.matches) return;
    document.querySelectorAll('[data-tilt]').forEach(function (el) {
      var max = parseFloat(el.getAttribute('data-tilt')) || 6;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ty', (x * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--tx', (-y * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--lift', '-0.4rem');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--ty', '0deg'); el.style.setProperty('--tx', '0deg'); el.style.setProperty('--lift', '0');
      });
    });
  }

  /* ---------- Contadores ---------- */
  function format(n, dec) {
    return n.toLocaleString('es-CL', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }
  function initCounters() {
    var els = document.querySelectorAll('[data-count-to]');
    if (!els.length) return;
    function setFinal(el) {
      var to = parseFloat(el.getAttribute('data-count-to')) || 0;
      var dec = parseInt(el.getAttribute('data-count-decimals'), 10) || 0;
      el.textContent = (el.getAttribute('data-count-prefix') || '') + format(to, dec) + (el.getAttribute('data-count-suffix') || '');
    }
    if (reduce.matches || !('IntersectionObserver' in window)) { els.forEach(setFinal); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var to = parseFloat(el.getAttribute('data-count-to')) || 0;
        var dec = parseInt(el.getAttribute('data-count-decimals'), 10) || 0;
        var pre = el.getAttribute('data-count-prefix') || '';
        var suf = el.getAttribute('data-count-suffix') || '';
        var dur = 1800, t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - k, 4);
          el.textContent = pre + format(to * eased, dec) + suf;
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Onda de tinta al pulsar un boton (microinteraccion del estado active) ---------- */
  var inkReady = false;
  function initInk() {
    if (inkReady || reduce.matches) return;
    inkReady = true;
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest && e.target.closest('.v-btn');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-loading')) return;
      var r = btn.getBoundingClientRect();
      var ink = document.createElement('span');
      ink.className = 'v-btn__ink';
      ink.setAttribute('aria-hidden', 'true');
      ink.style.setProperty('--rx', (e.clientX - r.left) + 'px');
      ink.style.setProperty('--ry', (e.clientY - r.top) + 'px');
      ink.style.setProperty('--ink', Math.ceil(Math.max(r.width, r.height) / 12) + 4);
      btn.appendChild(ink);
      ink.addEventListener('animationend', function () { ink.remove(); });
    }, { passive: true });
  }

  /* ---------- Animaciones infinitas: se pausan cuando no estan a la vista (ahorra bateria y fluidez) ---------- */
  function initPause() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.v-float, .v-hero__shadow, .v-journey__shadow, .v-hero__cue');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-paused', !e.isIntersecting); });
    }, { rootMargin: '10% 0px 10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    initReveal(); initTextReveal(); initScroll(); initTilt(); initCounters(); initPause();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Para el editor de Shopify: re-inicializa al cargar/mover secciones
  document.addEventListener('shopify:section:load', init);
  window.VidaMotion = { init: init, reduced: function () { return reduce.matches; } };
})();
